import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type CreateAttendUserHeaders =
  operations['AdminGroupEventController_createGroupEventMember']['parameters']['header'];

type CreateAttendUserPath =
  operations['AdminGroupEventController_createGroupEventMember']['parameters']['path'];

type CreateAttendUserData = components['schemas']['AdminCreateGroupEventMemberDto'];

interface CreateAttendUserProps {
  path: CreateAttendUserPath;
  data: CreateAttendUserData;
  headers?: OmitGroupIdInHeader<CreateAttendUserHeaders>;
}

type CreateAttendUserResponse = unknown;

export async function createAttendUser({
  path,
  data,
  headers,
}: CreateAttendUserProps): Promise<CreateAttendUserResponse | false> {
  const response = await authenticateRequest<CreateAttendUserResponse>({
    method: 'post',
    url: `/api/v1/admin/group-event/${path.groupEventId}`,
    data,
    headers,
  });

  console.log('postAttendUser', { response });
  return response;
}

export type { CreateAttendUserResponse };
